// Single source of truth for the team: the /equipo listing, the individual
// /equipo/:slug pages, their SEO metadata, structured data and the build-time
// sitemap + prerendered head tags (scripts/prerender-seo.js reads team.json
// directly, which is why the data lives in JSON rather than in this module).
//
// Adding a member: add an entry to team.json and rebuild — the route, metadata,
// structured data and sitemap entry are all derived from it.
//
// `bio: null` with `pendingBio: true` means no biography has been supplied yet.
// Those pages render name and role only; nothing is invented to fill the gap.

import team from './team.json';

export const TEAM = team;

export function getMember(slug) {
  return TEAM.find((m) => m.slug === slug);
}

export const memberPath = (slug) => `/equipo/${slug}`;
